import React from 'react';
import Switch from 'react-switch';
import classes from './ToggleSwitch.css';
import {PARTIAL_LOCK_WARN,FULL_LOCK_WARN} from '../../shared/Constants';

const toggleSwitch = (props) => {
    const isPartiallyLocked = props.offText === "Partial Lock" ;
    const toggleButton = isPartiallyLocked ? 
    (<div className={classes.ToggleButton}>
        <Switch
            id={props.id}
            onChange={props.clicked}
            checked={props.status}
            tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
            offColor="#FFA500" onColor="#32CD32" disabled={props.disabled}
            offHandleColor="#ccc" onHandleColor="#ccc"
            height={20} width={48} handleDiameter={30}/>
    </div>) :
        (<div className={classes.ToggleButton}>
            <Switch
                id={props.id}
                onChange={props.clicked}
                checked={props.status}
                tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
                offColor="#FF0000" onColor="#32CD32" disabled={props.disabled}
                offHandleColor="#ccc" onHandleColor="#ccc"
                height={20} width={48} handleDiameter={30}/>
        </div>);

        const warningMessage = (offText, status) => {
            if(!status){
            if(offText === "Locked"){
                return FULL_LOCK_WARN;
            }else if(offText === "Partial Lock"){
                return PARTIAL_LOCK_WARN;
            }
        }
        return "";
        };

    return (
        <div className={classes.Row}>
            <div className={classes.Label}>
                {props.labelText}
                <br/>{props.status ? <span className={classes.On}>{props.onText}</span> :
                <span className={classes.Off}>{props.offText}</span>}
                <br/>{props.isRBAToggle ? <span className={classes.Off}>{warningMessage(props.offText, props.status)}</span>:""}
            </div>
            {!props.hideToggleButton && toggleButton}
        </div>
    );
}

export default toggleSwitch;